module.exports = __webpack_public_path__ + "static/media/coltri-banner_2.030ed6a4.jpg";